import {createFeatureSelector, MemoizedSelector} from '@ngrx/store';
import {CATEGORY_FEATURE, CustomCategoryState, StateWithCategory} from '../custom-category-state';


export const getCategoryState: MemoizedSelector<StateWithCategory,
  CustomCategoryState> = createFeatureSelector<CustomCategoryState>(CATEGORY_FEATURE);
